import styled from 'styled-components';
import { StyledCalendarWrapperProps } from './BKJCalendar.types';

export const CalendarWrapper = styled.div<StyledCalendarWrapperProps>`
  width: 100%;
  height: 100%;
`;
